import InboxIcon from '@mui/icons-material/Inbox';
import BusinessIcon from '@mui/icons-material/Business';
import Groups3Icon from '@mui/icons-material/Groups3';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import PaidIcon from '@mui/icons-material/Paid';
import SchoolIcon from '@mui/icons-material/School';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import DriveEtaIcon from '@mui/icons-material/DriveEta';
import OfflineBoltIcon from '@mui/icons-material/OfflineBolt';
import WorkIcon from '@mui/icons-material/Work';
import PersonIcon from '@mui/icons-material/Person';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';

const getContainerIcon = (option = {}, style = { color: 'gray' }) => {

    if (option?.automatically_created) {
        switch (option.name) {
            case 'Health':
                return <LocalHospitalIcon style={style} />;
            case 'Finance':
                return <PaidIcon style={style} />;
            case 'Education':
                return <SchoolIcon style={style} />;
            case 'Entertainment':
                return <ConfirmationNumberIcon style={style} />;
            case 'Travel':
                return <DriveEtaIcon style={style} />;
            case 'Utility':
                return <OfflineBoltIcon style={style} />;
            case 'Work':
                return <WorkIcon style={style} />;
            case 'Personal':
                return <PersonIcon style={style} />;
            case 'Purchase':
                return <ShoppingCartIcon style={style} />;
            default:
                return <AutoAwesomeIcon style={style} />;
        }
    }

    switch (option?.type) {
        case 'department':
            return <BusinessIcon style={style} />;
        case 'team':
            return <Groups3Icon style={style} />;
        case 'project':
            return <AccountTreeIcon style={style} />;
        case 'container':
            return <InboxIcon style={style} />;
        default:
            return <InboxIcon style={style} />;
    }
}

const containerMethods = {
    getContainerIcon
}

export default containerMethods;
